import {
  Rocket, Brain, Flame, Target, Trophy, BookOpen, Dumbbell, Code2,
  Feather, Sparkles, Compass, Zap,
} from "lucide-react";
export const ICON_MAP = { Rocket, Brain, Flame, Target, Trophy, BookOpen, Dumbbell, Code2, Feather, Sparkles, Compass, Zap };
export function IconAvatar({ iconKey, size = "md", tone = "amber", className = "" }) {
  const Icon = ICON_MAP[iconKey] || Rocket;
  const sizes = { sm: "w-8 h-8", md: "w-11 h-11", lg: "w-14 h-14", xl: "w-20 h-20" };
  const iconSizes = { sm: "w-4 h-4", md: "w-5 h-5", lg: "w-6 h-6", xl: "w-9 h-9" };
  const tones = {
    amber: "bg-[#F59E0B] text-black",
    outline: "border border-[#F59E0B]/40 bg-[#F59E0B]/10 text-[#F59E0B]",
    ghost: "border border-white/10 bg-[#0f0f0f] text-[#A1A1AA]",
  };
  return (
    <span className={`inline-flex items-center justify-center rounded-md ${sizes[size]} ${tones[tone]} ${className}`}>
      <Icon className={iconSizes[size]} strokeWidth={1.5} />
    </span>
  );
}
